module.exports = __webpack_public_path__ + "static/media/background_sanar_v2.47f5eae0.png";